import i18n from '@/lang';
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export var actions = new Map([[/^(8|9|10|15|18)$/, function (val) {
  return Array.isArray(val.ovalue) ? val.ovalue.join(',') : '';
}], [/^(3|7|16)$/, function (val) {
  return val.ovalue;
}], [/^[456]$/, function (val) {
  return val.tfvvalue ? val.tfvvalue : '';
}], [/^default$/, function (val) {
  return val.tfvvalue ? val.tfvvalue : '';
}]]);
function flatArr() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return arr.reduce(function (p, c) {
    p = p.concat(c).concat(flatArr(c.dropList));
    return p;
  }, []);
}
// 获取选项等中文信息
export var valueNameActions = new Map([[/^3$/, function (val) {
  var data = val.dropList.find(function (item) {
    return Number(item.value) === Number(val.ovalue);
  });
  return data ? data.name : '';
}], [/^[456]$/, function (val) {
  return val.tfvvalue ? val.tfvvalue : '';
}], [/^8$/, function (val) {
  return val.dropList.filter(function (item) {
    return val.ovalue.indexOf(item.value) !== -1;
  }).map(function (item) {
    return item.name;
  }).join(',') || '';
}], [/^9$/, function (val) {
  return val.tfvvalue ? val.tfvvalue : '';
}], [/^(7|16)$/, function (val) {
  return val.ovalue === 1 ? i18n.tc("86") : i18n.tc("87");
}], [/^(10|15)$/, function (val) {
  return Array.isArray(val.ovalue) ? val.ovalue.join(',') : '';
}], [/^11$/, function (val) {
  return val.tfvvalue.split(',')[0] ? val.tfvvalue.split(',')[0] : '';
}], [/^(18)$/, function (val) {
  return val._name || flatArr(val.dropList).filter(function (item) {
    return val.ovalue.includes(item.id);
  }).map(function (item) {
    return item.label;
  }).join(',') || '';
}], [/^default$/, function (val) {
  return val.tfvvalue ? val.tfvvalue : '';
}]]);